import { render, staticRenderFns } from "./PrkSubjectsModal.vue?vue&type=template&id=0cdd7e48&"
import script from "./PrkSubjectsModal.vue?vue&type=script&lang=js&"
export * from "./PrkSubjectsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports